import React from "react";

const DeleteModal = ({
  modalId,
  title,
  button1,
  button2,
  onDelete,
  onCancel,
  content1,
  content2,
  keyId
}) => {
  // console.log(title)
  return (
    <div
    className="modal fade"
      key={keyId}
      id={modalId}
      data-bs-keyboard="false"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content blog_modal_content com_deletemodal88">
          <div className="modal-header border-0 text-center">
            <h5
              className="modal_delete_text_component w-100 headFont"
              id="staticBackdropLabel"
            >
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onCancel}
            ></button>
          </div>
          <div className="modal-body">
            <p className="modal_text_body_component headFont">
              {content1}
              <br /> {content2}
            </p>
          </div>
          <div className="py-3 px-3">
            <hr />
            {/* <div className='d-flex justify-content-between' >
                <button
                  data-bs-dismiss="modal"
                  onClick={onDelete}
                  type="button"
                  className="delete_blog">
                  {button1}
                </button>
                <button
                  type="button"
                  className="cancel_delete_blog"
                  data-bs-dismiss="modal">
                  {button2}
                </button>
            </div> */}
            <div className="d-flex float-end">
              <div
                style={{
                  cursor: "pointer",
                  backgroundColor: "#1f7e78",
                  color: "white",
                  border: "1px solid #bbb9b9",
                  height: "48px",
                  width: "90px",
                  float: "right",
                }}
                className="description_btnsave d-flex justify-content-center align-items-center"
                data-bs-dismiss="modal"
                onClick={onDelete}
              >
                {button1}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  color: "black",
                  border: "1px solid #bbb9b9",
                  height: "48px",
                  width: "90px",
                }}
                className="description_btnsave d-flex justify-content-center align-items-center"
                data-bs-dismiss="modal"
                onClick={onCancel}
              >
                {button2}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
